import PropTypes from 'prop-types';

export default PropTypes.shape({
    reference: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    logoAsLargeThumbnail:  PropTypes.string,
    nbAlbums: PropTypes.number.isRequired,
});
